import { Injectable } from '@angular/core';
import cryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  passphrase = 'encoded data from Bhulka Sagar Vidhyabhavan';

  deleteAllData(): void {
    localStorage.clear();
  }

  getData(item: string): any {
    if (typeof localStorage !== 'undefined') {
      const encodeData = localStorage.getItem(item);
      if (encodeData) {
        if (!encodeData) {
          return null;
        }
        const bytes = cryptoJS.AES.decrypt(encodeData, this.passphrase);
        const decryptedText = bytes.toString(cryptoJS.enc.Utf8);
        return decryptedText;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  setData(item: string, values: any): void {
    const cryptoData: any = cryptoJS.AES.encrypt(values, this.passphrase).toString();
    localStorage.setItem(item, cryptoData);
  }

  deleteData(item: string): void {
    localStorage.removeItem(item);
  }
}
